export const countryCodes = [
  {
    "country": "NO",
    "name": "Norway",
    "eu": false,
    "language": "nb",
    "currency": "NOK",
    "pricelist": "23",
    "market": "5"
  }
];